<template>
  <div class="bg-white rounded-md w-full flex justify-center items-center sticky top-0 z-10 select-none">
    <ToastComponent ref="globalToast" class="mx-auto"/>
    <div v-for="tabObject in tabs" :key="tabObject.name"
      class="text-lg font-medium text-center text-gray-500 dark:text-gray-400 dark:border-gray-700">
      <button v-if="showTabIfPermissionGranted(tabObject.permission)"
      :class="[commonStyle, currentTab === tabObject.name ? selectedStyle : '']"
          @click="switchTab(tabObject.name)">
          {{ $t(`tabSelector.${tabObject.name}`)}}
      </button>
    </div>
  </div>
  <div class="px-5 text-center rounded-md select-none">
    <div>
      <TransitLiveTab v-if="currentTab == 'live'"/>
      <TransitHistoryTab v-else-if="currentTab == 'history'"/>
      <StatsTab v-else-if="currentTab == 'stats'" />
      <ObjectTab v-else-if="currentTab == 'objects'" />
      <FacilityTab v-else-if="currentTab == 'facility'" />
      <UsersTab v-else-if="currentTab == 'users'" />
      <SecurityTab v-else-if="currentTab == 'security'" />
    </div>
  </div>
  <div class="flex flex-col justify-center align-middle w-full text-center text-xs mb-5 select-none">
    <span>ARS Dashboard © <span class="font-bold">v{{ this.applicationVersion }}</span> (2025)</span>
    <span>AllRead Machine Learning Technologies S.L. All Rights Reserved</span>
  </div>
</template>

<script>
import { version } from '@/../package.json';
import useUserManagementStore from '@/stores/UserManagementStore';
import useTransitStore from '@/stores/TransitStore';
import TransitHistoryTab from './TransitHistoryTab.vue';
import TransitLiveTab from './TransitLiveTab.vue';
import StatsTab from './StatsTab.vue';
import ObjectTab from './ObjectTab.vue';
import FacilityTab from './FacilityTab.vue';
import UsersTab from './UsersTab.vue';
import SecurityTab from './SecurityTab.vue';
import ToastComponent from './generic/ToastComponent.vue';

export default {
  name: 'TabSelector',
  data() {
    return {
      applicationVersion: version,
      currentTab: 'live',
      commonStyle: 'inline-block px-5 py-3 border-b-4 border-transparent hover:text-sky-400 hover:border-sky-400',
      selectedStyle: 'text-sky-700 border-sky-700 bg-sky-50',
      tabs: [
        { name: 'live', permission: '' },
        { name: 'history', permission: '' },
        { name: 'objects', permission: '' },
        { name: 'stats', permission: '' },
        { name: 'facility', permission: 'facility_tab' },
        { name: 'users', permission: 'all_users_read' },
        { name: 'security', permission: 'security_policy_tab' },
      ],
    };
  },
  components: {
    TransitHistoryTab,
    TransitLiveTab,
    StatsTab,
    ObjectTab,
    FacilityTab,
    UsersTab,
    SecurityTab,
    ToastComponent,
  },
  methods: {
    switchTab(mode) {
      this.currentTab = mode;
    },
    showTabIfPermissionGranted(permissionName) {
      if (!permissionName) {
        return true;
      }
      return useUserManagementStore().hasPermissionName(permissionName);
    },
  },
  mounted() {
    this.emitter.on('show-toast', (toastInfo) => {
      this.$refs.globalToast.openToast(toastInfo);
    });
    useUserManagementStore().startRefreshTokenPeriodicJob();
    useTransitStore().fetchStreams();
  },
  unmounted() {
    this.emitter.off('show-toast');
    useUserManagementStore().stopRefreshTokenPeriodicJob();
  },
};
</script>
